module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"intro":"倉庫探しは","warex":"ウェアエックス","h1":":あなたの欲しい倉庫が:、:カンタンに見つかる:","doSignUp":{"text":"無料登録で","or":"or","warehouse":"倉庫を探す","price":"倉庫料金を見る"},"cm":"15秒動画をチェック！"}}')
  delete Component.options._Ctor
}
